module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-1.png?ef4d2823";